module.exports = __webpack_public_path__ + "diligent-logotype-dark-d497b9fa81574c53be1dd4a11b8bf195.svg";